// #region imports

// --- HS Code
import { CommandResult } from './command-result';
import { CommandTypes } from './command-types';

// #endregion

export interface RemoteCommand {
  commandId: number,
  commandType: CommandTypes;
  commandResult: CommandResult | undefined;
  identifier: string;
  isExecuted: boolean;
  undo(): RemoteCommand;
  createCommandDto(): any;
}
